import * as Sentry from "@sentry/react-native";
import { init } from "@sentry/react-native";
import noop from "lodash/noop";
import { Platform } from "react-native";
import Url from "url-parse";
import { Environment, environment, SENTRY_DSN } from "./constants";
import { _configuration } from "./lib/NetInfo";
import SentryRRWeb from "./rrweb";
export var routingInstrumentation = Sentry.reactNavigationIntegration();
var sentry = Sentry;
var isWeb = Platform.OS === 'web';
function sanitizeUrl(source) {
    var url = new Url(source, {}, {
        parser: true
    });
    Object.keys(url.query).forEach(function(key) {
        if ([
            'token',
            'authToken',
            'password',
            'resetToken'
        ].includes(key)) {
            url.query[key] = '[redacted]';
        }
    });
    return url.toString();
}
if (process.env.NODE_ENV !== 'test') {
    init({
        enabled: process.env.NODE_ENV !== 'development',
        beforeSend: function(evt, b) {
            var _evt_request, _evt_request_headers, _evt_request1;
            if ((_evt_request = evt.request) === null || _evt_request === void 0 ? void 0 : _evt_request.url) {
                evt.request.url = sanitizeUrl(evt.request.url);
            }
            if ((_evt_request1 = evt.request) === null || _evt_request1 === void 0 ? void 0 : (_evt_request_headers = _evt_request1.headers) === null || _evt_request_headers === void 0 ? void 0 : _evt_request_headers['Referer']) {
                evt.request.headers['Referer'] = sanitizeUrl(evt.request.headers['Referer']);
            }
            return evt;
        },
        environment: environment,
        dsn: SENTRY_DSN,
        maxBreadcrumbs: 100,
        enableAutoSessionTracking: true,
        enableAppHangTracking: false,
        beforeBreadcrumb: function beforeBreadcrumb(breadcrumb, hint) {
            var _breadcrumb_data, _breadcrumb_data1, _breadcrumb_data2;
            var is204 = breadcrumb.category === 'xhr' && ((_breadcrumb_data = breadcrumb.data) === null || _breadcrumb_data === void 0 ? void 0 : _breadcrumb_data.url) === _configuration.reachabilityUrl && ((_breadcrumb_data1 = breadcrumb.data) === null || _breadcrumb_data1 === void 0 ? void 0 : _breadcrumb_data1.status_code) === 204;
            var isMuxData = breadcrumb.category === 'xhr' && ((_breadcrumb_data2 = breadcrumb.data) === null || _breadcrumb_data2 === void 0 ? void 0 : _breadcrumb_data2.url) === 'https://ube37gkhuapjipih1qa0ul5e2.litix.io';
            return is204 || isMuxData ? null : breadcrumb;
        },
        tracesSampleRate: 0.05,
        enableAutoPerformanceTracing: false,
        enableAppStartTracking: !isWeb,
        enableStallTracking: !isWeb,
        enableNativeFramesTracking: !isWeb,
        tracePropagationTargets: [
            'localhost',
            'oui.dev',
            'oui.health'
        ],
        integrations: [
            routingInstrumentation,
            SentryRRWeb && environment !== Environment.PRODUCTION ? new SentryRRWeb({
                maskAllInputs: false,
                collectFonts: true
            }) : undefined,
            Platform.OS !== 'web' ? Sentry.mobileReplayIntegration() : undefined
        ].filter(function(i) {
            return !!i;
        }),
        replaysOnErrorSampleRate: 1,
        replaysSessionSampleRate: 0
    });
} else {
    var IS_TEST = process.env.NODE_ENV === 'test';
    var log = IS_TEST ? noop : console.log;
    sentry = {
        addBreadcrumb: noop,
        captureException: IS_TEST ? noop : console.warn,
        captureMessage: log,
        setUser: noop,
        nativeCrash: function() {
            return console.warn('Enable Sentry in development to enable nativeCrash');
        },
        withScope: function(cb) {
            return cb({
                setExtra: log,
                setExtras: log,
                setTag: log
            });
        }
    };
}
export default sentry;
